export enum FeatureFlags {
  AUTOREGISTRACIA_EDIT_RC = 'autoregistracia-edit-rc',
  PORTAL_ZOAK = 'portal-zoak',
  PORTAL_REGISTRACIA_TLACIDLO = 'portal-registracia-tlacidlo',
  PORTAL_PRIHLASENIE_TLACIDLO = 'portal-prihlasenie-tlacidlo',
  ZOP = 'zop',
}

const featureFlags = document
  .getElementsByName('FEATURE_FLAGS')[0]
  ?.getAttribute('content')
  ?.toString()
  .replace(/\s/g, '')

export function isFeatureFlag(featureFlag: string): boolean {
  if (featureFlags == '${FEATURE_FLAGS}') {
    //development
    return true
  }
  const featureFlagsSplited: Array<string> = featureFlags?.split(',')
  if (featureFlagsSplited.includes(featureFlag)) {
    return true
  } else {
    return false
  }
}
